import axios from 'axios'
import { trackPromise } from 'react-promise-tracker'
import { getInvoiceList, getInvoiceById, saveInvoice } from '../invoice/InvoiceFunctions'
import { getReceiptsList } from '../receipt/ReceiptFunctions'

const calculateTotals = async (app, customer_account, lic) => {
  const receiptsList = await getReceiptsList(app, null, lic)
  const invoiceList = await getInvoiceList(app, null, lic)
  const customerCreditAccountsReceipts = receiptsList.filter(receipt => receipt.receipt_for.item_name === 'Customer Credit Account')

  for (let credit_account of customer_account.credit_accounts) {
    credit_account.total_amount = 0
    credit_account.total_balance = 0
    let total_payment = 0
    for (let invoice of credit_account.invoices) {
      const current_invoice = invoiceList.find(inv => inv._id === invoice.invoice_number)
      invoice.invoice_summary = current_invoice.invoice_summary
      invoice.invoice_date = new Date(current_invoice.date_time_created).toLocaleString()
      invoice.sold_to = current_invoice.customer_details.sold_to
      credit_account.total_amount += current_invoice.invoice_summary.total_sales
    }

    // Compute total_balance
    // Read from receipt a total_amount paid for each credit record
    const cus_cre_acc = customerCreditAccountsReceipts.filter(cca => cca.receipt_for.item_id.credit_account_number === credit_account.credit_account_number)
    for (let cca of cus_cre_acc) {
      total_payment += cca.payments[0].total_amount_paid
    }

    credit_account.total_balance = credit_account.total_amount - total_payment

    if (credit_account.total_balance <= 0) {
      if (credit_account.total_amount !== 0) {
        credit_account.total_balance = 0
        credit_account.status = 'Settled'
      }
    } else {
      credit_account.status = (credit_account.status !== 'On Process') ? 'Unsettled' : 'On Process'
    }

    customer_account.credit_total_amount = credit_account.total_amount
    customer_account.credit_total_balance = credit_account.total_balance
  }
}

/** Filered Customers Accounts list */
export const getCustomersAccountsList = async (app, filter) => {
  let customers_accounts = null
  const { date } = filter
  app.startLoadingIndicator()
  await trackPromise (
    axios.get(app.API_URI + `/customersaccounts/filter?dc_from=${date.date_created_from}&dc_to=${date.date_created_to}&dm_from=${date.date_modified_from}&dm_to=${date.date_modified_to}`)
    .then(result => {
      customers_accounts = result.data
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return customers_accounts
}

export const saveCustomer = async (app, customer_account, lic) => {
  let customer = null
  lic = lic || 'loading-indicator-container'
  // Necessary so that you escape copying object as reference
  const customerAccount = await JSON.parse(JSON.stringify(customer_account))

  // calculateTotals here
  await calculateTotals(app, customerAccount, lic)

  delete customerAccount.search_string

  customerAccount.credit_accounts.forEach(credit_account => {
    delete credit_account.total_amount
    credit_account.invoices.forEach(invoice => {
      delete invoice.total_amount_due
      delete invoice.invoice_date
      delete invoice.sold_to
    })
  })

  customerAccount.signed_in = app.client.signed_in

  app.startLoadingIndicator("Saving Customer Account")
  if (!customerAccount._id)
    await trackPromise (
      axios.post(app.API_URI + '/customersaccounts', customerAccount)
      .then(async (result) => {
        customer = result.data
        app.stopLoadingIndicator()
      })
      .catch(error => { app.errorLoadingIndicator(error) })
    )
  else
    await trackPromise (
      axios.put(app.API_URI + `/customersaccounts?customer_id=${customerAccount._id}`, customerAccount)
      .then(async (result) => {
        customer = result.data
        app.stopLoadingIndicator()
      })
      .catch(error => { app.errorLoadingIndicator(error) })
    )
  return customer
}

export const getCustomerAccountById = async (app, id) => {
  let customer_account = null
  const receiptsList = await getReceiptsList(app)
  const invoiceList = await getInvoiceList(app)
  const customerCreditAccountsReceipts = receiptsList.filter(receipt => receipt.receipt_for.item_name === 'Customer Credit Account')

  app.startLoadingIndicator("Getting customer record")
  await trackPromise (
    axios.get(app.API_URI + `/customersaccounts?customer_id=${id}`)
    .then(async (result) => {
      customer_account = result.data

      for (let credit_account of customer_account.credit_accounts) {
        credit_account.total_amount = 0
        credit_account.total_balance = 0
        let total_payment = 0
        for (let invoice of credit_account.invoices) {
          const current_invoice = invoiceList.find(inv => inv._id === invoice.invoice_number)
          //invoice.total_amount_due = current_invoice.invoice_summary.total_amount_due
          invoice.invoice_summary = current_invoice.invoice_summary
          //invoice.invoice_date = new Date(current_invoice.date_time_created.toLocaleString()).toLocaleString()
          invoice.invoice_date = new Date(current_invoice.date_time_created).toLocaleString()
          invoice.sold_to = current_invoice.customer_details.sold_to
          credit_account.total_amount += current_invoice.invoice_summary.total_sales
        }

        // Compute total_balance
        // Read from receipt a total_amount paid for each credit record
        const cus_cre_acc = customerCreditAccountsReceipts.filter(cca => cca.receipt_for.item_id.credit_account_number === credit_account.credit_account_number)
        for (let cca of cus_cre_acc) {
          total_payment += cca.payments[0].total_amount_paid
        }

        credit_account.total_balance = credit_account.total_amount - total_payment
        if (credit_account.total_balance <= 0) {
          if (credit_account.total_amount !== 0) {
            credit_account.total_balance = 0
            credit_account.status = 'Settled'
          }
        } else { credit_account.status = 'Unsettled' }

        customer_account.credit_total_amount = credit_account.total_amount
        customer_account.credit_total_balance = credit_account.total_balance
      }

      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return customer_account
}

export const deleteCustomerAccount = async (app, id) => {
  let delete_ca = null

  app.startLoadingIndicator("Delting Customer Account")
  await trackPromise (
    axios.delete(app.API_URI + `/customersaccounts?customer_id=${id}`)
      .then(async (result) => {
        delete_ca = result.data
        app.stopLoadingIndicator()
      })
      .catch(error => { app.errorLoadingIndicator(error) })
  )
  return delete_ca
}

export const getCustomersAccountsSettings = async (app) => {
  let ca_settings = null
  const user_id = (app.client.signed_in === 'admin') ? app.client.signed_in : app.client.signed_in.id

  app.startLoadingIndicator()
  await trackPromise (
    axios.get(app.API_URI + `/settings?user_id=${user_id}&field=customers_accounts`)
    .then(result => {
      if (result.data) {
        ca_settings = result.data 
        app.stopLoadingIndicator()
      } 
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return ca_settings
}

export const saveCustomersAccountsSettings = async (app, settings) => {
  let save_ca_settings = null
  const user_id = (app.client.signed_in === 'admin') ? app.client.signed_in : app.client.signed_in.id

  app.startLoadingIndicator("Saving settings")
  await trackPromise (
    axios.put(app.API_URI + `/settings?user_id${user_id}&field=customers_accounts`, settings)
    .then(result => {
      save_ca_settings = result.data
      app.stopLoadingIndicator()
    })
    .catch(error => { app.errorLoadingIndicator(error) })
  )
  return save_ca_settings
}

export { getInvoiceById, saveInvoice, getReceiptsList }